import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const familyUpgradeTariff2 = getFeature('family-upgrade-tariff2') as Record<number, string>;

/** id промо - для включения нужно будет включать фичу app.enableFeature('3promo-enable-upgrade-family-modal2') */
export const PROMO_ID = 'upgrade-family-modal2';

export const config = getFeature(`${PROMO_ID}-config`) || {
    showLimit: 3,
    closeLimit: 3,
    showInterval: 60 * 60 * 24 * 3,
};
